import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { positionModifier, sizeModifier } from './styles'

/**
* @deprecated this component will soon be made internal-to-Pinata only.
Rather use TooltipPopupTip as it supports both desktop and mobile devices
*/
const Tooltip = props => {
  const { children, trigger: Trigger, className, position, tooltipSize, tabIndex = 0, isEnabled = true, ...rest } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleVisibility = isVisible => {
    if (isEnabled) {
      setIsOpen(isVisible)
      if (isVisible && props.onOpen) props.onOpen()
    }
  }

  useEffect(() => {
    if (!isEnabled) setIsOpen(false)
  }, [isEnabled])

  return (
    <div
      className={cx(styles.wrapper, className)}
      onMouseEnter={() => {
        handleVisibility(true)
      }}
      onMouseLeave={() => {
        handleVisibility(false)
      }}
      onFocus={() => {
        handleVisibility(true)
      }}
      onBlur={() => {
        handleVisibility(false)
      }}
      tabIndex={tabIndex}>
      <Trigger
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
      {Boolean(isOpen && isEnabled) && (
        <div className={cx(styles.body, positionModifier(position, tooltipSize), sizeModifier(tooltipSize))}>{children}</div>
      )}
    </div>
  )
}

const { func, string, number, bool, node, shape, oneOfType, oneOf, arrayOf } = PropTypes
Tooltip.propTypes = {
  trigger: func,
  className: string,
  triggerProps: shape({}),
  children: oneOfType([arrayOf(node), node]),
  onOpen: func,
  position: oneOf([
    'bottom',
    'top',
    'left',
    'right',
    'bottom-left',
    'bottom-right',
    'top-left',
    'top-right',
    'left-top',
    'left-bottom',
    'right-top',
    'right-bottom',
  ]),
  tooltipSize: oneOf(['', 'default', 'small']),
  tabIndex: oneOfType([string, number]),
  isEnabled: bool,
}

Tooltip.defaultProps = {
  triggerProps: {},
  position: 'bottom',
  tooltipSize: 'default',
}

export default Tooltip
